import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';

export class MenuItem extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates(`MenuItem`);
		Eventify(this.el, this);
		this._configured = false;
	}
	connectedCallback() {
		if (!this.firstElementChild) {
			document.addEventListener(`DOMContentLoaded`, evt=>this.connectedCallback());
			return;
		}
		/** This can be called twice, not sure why... so we prevent ourselves being run twice with a flag */
		if (this._configured) return;
		this._configured = true;
		this.$.title.innerHTML = this.getAttribute(`title`);
		// transfer all our children to children of this.el
		while (this.firstElementChild) {
			this.$.dropdown.appendChild(this.firstElementChild);
		}
		this.appendChild(this.el);
	}
	click(evt) {
		evt.preventDefault();
		this.el.classList.toggle('show');
	}
}

export class TopMenu extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates(`TopMenu`);
		this.attachShadow({mode:'open'});
		this.shadowRoot.appendChild(this.el);
	}
	connectedCallback() {
		if (!this.firstElementChild) {
			document.addEventListener(`DOMContentLoaded`, evt=>this.connectedCallback());
			return;
		}
		while (this.firstElementChild) {
			this.shadowRoot.appendChild(this.firstElementChild);
		}
	}
}

customElements.define(`dojo-top-menu`, TopMenu);
customElements.define(`dojo-menu-item`, MenuItem);